<template>
    <filters-wrapper :has-active-filters="props.hasActiveFilters" @submit="emit('submit')" @reset="emit('reset')">
        <template v-slot:panel>
            <FilterStatusToggle v-model="filters.active" @update:model-value="emit('submit')" />
        </template>
        <v-form class="table-filters">
            <v-row dense>
                <v-col cols="12" md="3" sm="6">
                    <v-text-field
                        v-model="filters.name"
                        :label="$t('name')"
                        density="compact"
                        variant="outlined"
                        color="primary"
                        data-cy="department-name"
                    />
                </v-col>
            </v-row>
        </v-form>
    </filters-wrapper>
</template>

<script setup lang="ts">
    import type {DepartmentFiltersType} from '~/utils/types/account/departments/types'

    const props = defineProps<{
        hasActiveFilters: boolean
    }>()

    const filters = defineModel<DepartmentFiltersType>()
    const emit = defineEmits<{
        (e: 'submit' | 'reset'): void
    }>()
</script>
